import { queryUacMenu } from './services/user';
import { getAllAllowedRoutes, getRouteFilterByUac } from './utils/routerUtil';

// umi 用于运行时修改路由，注释的原因：
// patchRoutes的运行在authorized鉴权前，从而调用menu接口在鉴权接口/user前面，
// 会导致无权限下调用接口多次sso的callback重复拼接,暂时把此逻辑放到uacauthorized中
// export async function patchRoutes(routes) {
  // let uacMenuRes = {}
  // try {
  //   uacMenuRes = await queryUacMenu();
  // } catch (e) {
  //   console.warn('UAC鉴权接口失败');
  // }
  // const uacMenusList = uacMenuRes.menuFolderList || [];
  // const allAllowedRoutes = getAllAllowedRoutes(uacMenusList);
  // routes && routes.forEach(item => {
  //   // 过滤没有UAC权限的路由，checkUac代表需检查
  //   if(item.checkUac && item.routes) {
  //     item.routes = getRouteFilterByUac(item.routes, allAllowedRoutes);
  //   }
  // });
// }
